<template>
    <div
        id="PersonalProfileSideButtons"
        class="ml-auto flex h-fit w-full flex-col items-end space-y-2 sm:mb-0"
        :class="{
            'fixed bottom-0 left-0 z-10 flex w-full bg-white dark:bg-surface-card p-4 shadow-navbar sm:relative sm:bg-transparent sm:p-0 sm:shadow-none':
                fixedOnMobile
        }"
    >
        <CButton full icon="edit" size="large" :to="{ name: 'u' }" variant="primary-150"> Upraviť životopis </CButton>
        <CButton
            full
            icon="jobs"
            size="large"
            :to="
                talentBaseProfileSlug
                    ? { name: 'talentbase-talenty-slug', params: { slug: talentBaseProfileSlug } }
                    : { name: 'talentbase-join' }
            "
        >
            Môj pracovný profil
        </CButton>
        <CButton
            full
            icon="volunteering"
            size="large"
            :to="{
                name: 'dobrovolnictvo-dobrovolnici-id',
                params: { id: profileSlug || profileId }
            }"
        >
            Môj dobrovoľnícky profil
        </CButton>
        <CButton
            full
            icon="mentoring"
            size="large"
            :to="{ name: 'mentor-id', params: { id: profileSlug || profileId } }"
        >
            Môj mentorský profil
        </CButton>
    </div>
</template>

<script setup lang="ts">
defineProps({
    profileId: {
        type: String,
        default: undefined
    },
    profileSlug: {
        type: String,
        default: undefined
    },
    talentBaseProfileSlug: {
        type: String,
        default: undefined
    },
    fixedOnMobile: {
        type: Boolean,
        default: false
    }
})
</script>
